import { Outlet } from "react-router";

export function CountingsRoute() {
  return <Outlet />;
}
